export default "__VITE_ASSET__BSz8Gub2__"